import React from "react";
import {IconDocumentLinesCircle} from "../../../../../../components/buttons/IconButtons";
import CustomUserChip from "../../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import {THERMO_TRAILER_SECTIONS} from "../../../Model/Model";
import PoultryTruckExitTransportSection from "./PoultryTruckExitTransportSection";
import ThermoTrailerSection from "./ThermoTrailerSection";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @description
 * Renders the sections of a poultry truck exit form: the transport that leaves
 * the plant and the thermo trailers it pulls, which are captured with the same
 * fields and are rendered from their configuration.
 *
 * @param {Function} t - Translation function.
 * @param {Function} handleChange - Change handler of the form.
 * @param {Object} materialRequest - Current form information.
 * @param {boolean} emptyFields - Indicates whether the required fields must be highlighted.
 */
const PoultryTruckExitSections = ({
    t,
    handleChange,
    materialRequest,
    emptyFields
}) => {

    return (
        <div className='col-12 py-3 mt-3 border-radius-8px background-secondary-50 border-dashed-secondary-150'>
            <CustomUserChip
                className='mt-0 p-0 chip-secondary-150-100 justify-content-start d-flex w-100'
                name={t('any_field_you_leave_blank_will_be_completed_by_the_guard_at_the_gate')}
                Icon={IconDocumentLinesCircle}
                showAvatar={true}
                classNameIcon={'icon-color-secondary-700'}
                variant='large'
                iconPosition={POSITION_MODEL.LEFT}
            />

            <PoultryTruckExitTransportSection
                t={t}
                materialRequest={materialRequest}
                handleChange={handleChange}
                emptyFields={emptyFields}
            />

            { THERMO_TRAILER_SECTIONS.map((section) => (
                <ThermoTrailerSection
                    key={section.fieldName}
                    t={t}
                    section={section}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    required={false}
                />
            ))}
        </div>
    );
};

export default PoultryTruckExitSections;
